import React from 'react'

import {
  StyledHeading,
  StyledDesc,
  StyledWrapper,
  StyledThumb,
  StyledBtn,
} from './index.styled'

export type Props = {
  heading?: string
  desc?: string
  btnLabel?: string
  onBtnClick?: (e: any) => void
}

const NotiScreen = ({
  heading,
  desc,
  btnLabel,
  onBtnClick,
  ...rest
}: Props) => {
  return (
    <StyledWrapper {...rest}>
      <StyledThumb src={'/icons/question-mark.svg'} />
      {heading && <StyledHeading>{heading}</StyledHeading>}
      {desc && <StyledDesc>{desc}</StyledDesc>}
      {btnLabel && (
        <StyledBtn size="lg" onClick={onBtnClick} theme="marryBaby">
          {btnLabel}
        </StyledBtn>
      )}
    </StyledWrapper>
  )
}

export { NotiScreen }
